import { ClipboardEvent, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ExpenseTypeFilter } from 'core/application/expenses/getUserAvailableExpenseTypes'
import debounce from 'core/utilities/debounce'

import { Icon, SimpleInput } from 'common/components'

import './ExpenseType.less'

type ExpenseSearchProps = {
  onExpenseSearch: (value: string) => void
  onClearExpenseSearch: () => void
  expenseFilter: ExpenseTypeFilter
}

const ExpenseSearch = ({ onExpenseSearch, onClearExpenseSearch, expenseFilter }: ExpenseSearchProps) => {
  const { t: translate } = useTranslation('ee-dashboard')
  const [searchValue, setSearchValue] = useState<string>('')

  const debouncedOnExpenseSearch = useCallback(
    debounce((value: string) => {
      onExpenseSearch(value)
    }, 300),
    [],
  )

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    const text = e.clipboardData.getData('text')
    onExpenseSearch(text.trimStart())
    setSearchValue(text.trimStart())
  }

  useEffect(() => {
    if (expenseFilter.searchValue === '') setSearchValue('')
  }, [expenseFilter.searchValue])

  return (
    <div className="width-100 flex justify_center">
      <SimpleInput
        placeholder={translate('get-reimburse.expense-type.expense-search-placeholder')}
        suffix={searchIcon}
        allowClear
        value={searchValue}
        onPaste={handlePaste}
        spellCheck="true"
        onChange={(e) => {
          if (e.target.value === '') {
            onClearExpenseSearch()
          } else {
            debouncedOnExpenseSearch(e.target.value)
          }
          setSearchValue(e.target.value)
        }}
      />
    </div>
  )
}

const searchIcon = <Icon type="fal fa-search" fontAwesome />

export default ExpenseSearch
